import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-surface-container-lowest border-t border-outline-variant">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center px-4 md:px-margin-desktop py-8 max-w-container mx-auto gap-8">
        <div className="flex items-center gap-2">
          <span className="font-headline text-headline-sm font-bold text-primary">Meettix</span>
        </div>

        <div className="flex flex-wrap gap-6">
          <Link to="/" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            {t('nav.home')}
          </Link>
          <Link to="/events" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            {t('nav.events')}
          </Link>
          <a href="#" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            Sobre nós
          </a>
          <a href="#" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            Privacidade
          </a>
          <a href="#" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            Termos
          </a>
          <a href="#" className="font-headline text-label-md text-on-surface-variant hover:text-primary transition-colors">
            Suporte
          </a>
        </div>

        <div className="font-headline text-label-md text-on-surface-variant">
          © {currentYear} Meettix Inc.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
